import { render, staticRenderFns } from "./PasswordEmailIdentify.vue?vue&type=template&id=7296566c"
import script from "./PasswordEmailIdentify.vue?vue&type=script&lang=js"
export * from "./PasswordEmailIdentify.vue?vue&type=script&lang=js"
import style0 from "./PasswordEmailIdentify.vue?vue&type=style&index=0&id=7296566c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports